import { combineReducers } from 'redux'
import { createFullCycleHandlers } from 'utils/reducers'
import actions from 'actions/crm/workingStatus'
import state from './initial.state'

export default combineReducers({
  settings: createFullCycleHandlers(actions.settings, state.working_status.settings)
})
